import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Blender = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      {...rest}
      fill={fill}
    >
      <path d="M6.667 3.333h2C8.85 3.333 9 3.183 9 3s-.15-.333-.333-.333h-2c-.183 0-.333.15-.333.333s.15.333.333.333zM6.667 5.333h2C8.85 5.333 9 5.183 9 5s-.15-.333-.333-.333h-2c-.183 0-.333.15-.333.333s.15.333.333.333zM6.667 7.333h2C8.85 7.333 9 7.183 9 7s-.15-.333-.333-.333h-2c-.183 0-.333.15-.333.333s.15.333.333.333zM7.667 12c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 1.333c-.183 0-.333-.15-.333-.333s.15-.333.333-.333c.183 0 .333.15.333.333s-.15.333-.333.333z" />
      <path d="M10.177 10.333h-5.02c-.823 0-1.533.613-1.65 1.43l-.503 3.523c-.013.097.013.193.077.267s.157.113.253.113h8.667a.327.327 0 0 0 .33-.38l-.503-3.523a1.674 1.674 0 0 0-1.65-1.43zM3.717 15l.45-3.14c.07-.49.497-.86.99-.86h5.023c.493 0 .92.37.99.86l.45 3.14H3.717zM13.667.333H2.334a.327.327 0 0 0-.293.177.321.321 0 0 0 .017.34l1.277 1.917v2.567c0 2.417 1.023 3.81 1.067 3.867a.334.334 0 0 0 .534-.4c-.01-.013-.933-1.27-.933-3.467V2.667c0-.067-.02-.13-.057-.183l-.987-1.483h8.377v4.333c0 2.173-.917 3.447-.933 3.467a.334.334 0 0 0 .534.401c.037-.05.79-1.08 1.007-2.89 1.26-.173 2.06-1.433 2.06-3.31V.669a.334.334 0 0 0-.333-.333zM13.334 3c0 1.16-.36 2.383-1.34 2.623 0-.097.007-.19.007-.29V1h1.333v2z" />
    </svg>
  );
};

Blender.category = 'product-category';

Blender.displayName = 'Blender';
